<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 17.5H2.83333M17.5 1V2.83333M32.1667 17.5H34M17.5 32.1667V34M5.76667 5.76667L7.05 7.05M29.2333 5.76667L27.95 7.05M27.95 27.95L29.2333 29.2333M7.05 27.95L5.76667 29.2333M7.07895 17.5C7.07895 20.2638 8.17688 22.9145 10.1312 24.8688C12.0855 26.8231 14.7362 27.9211 17.5 27.9211C20.2638 27.9211 22.9145 26.8231 24.8688 24.8688C26.8231 22.9145 27.9211 20.2638 27.9211 17.5C27.9211 14.7362 26.8231 12.0855 24.8688 10.1312C22.9145 8.17688 20.2638 7.07895 17.5 7.07895C14.7362 7.07895 12.0855 8.17688 10.1312 10.1312C8.17688 12.0855 7.07895 14.7362 7.07895 17.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>